import config from "../config";
import HttpClient from "../helpers/httpclient";

export const SYNC_STATUS_CHANGED_EVENT = "asset:sync-status-changed";
const CLEAR_CONFIRMATION = "CLEAR_STALE_TAMARAC_SYNC_STATUS";

export type SyncStatusClearResult = {
  outcome: "safe_to_clear" | "cleared";
  previous_status: number;
  new_status: number;
  active_job_count: number;
  active_worker_jobs: Array<{ id: string; name: string }>;
  active_report_jobs: Array<{ id: string; name: string }>;
  started_import_rows: number;
};

async function requestSyncStatusClear(reason: string, dryRun: boolean): Promise<SyncStatusClearResult> {
  const response = await HttpClient.post(`${config.api}/reports/sync-status/clear`, {
    reason,
    dry_run: dryRun,
    ...(dryRun ? {} : { confirmation: CLEAR_CONFIRMATION }),
  });
  return response.data;
}

export async function checkSyncStatusClear(reason: string): Promise<SyncStatusClearResult> {
  return requestSyncStatusClear(reason, true);
}

export async function clearSyncStatus(reason: string): Promise<SyncStatusClearResult> {
  const result = await requestSyncStatusClear(reason, false);
  window.dispatchEvent(new Event(SYNC_STATUS_CHANGED_EVENT));
  return result;
}
